$.namespace("common.app");
common.app = {
    IOS_TYPE: "10",
    AOS_TYPE: "20",
    parser : null, 
    appInfo : null,
    
    scrollInterval : null,
    appMktFlag : null,
    pushConfigResult : null,
    
    isMessageEventSet: false,

    setSessionStorageBridge() {
        // sessionStorageBridge가 이미 정의되어 있는 경우, 중복 정의를 방지
        if (window.sessionStorageBridge) {
            return;
        }

        window.sessionStorageBridge = {
            keys: ["shopAlimGetTime",
                "liveNudgeSkip",
                "shopAlimOlLiveList",
                "wishList",
                "checkLoginStatus",
                "todayDeliveryAddressList",
                "loginInfoDone",
                "gtmPreviousTitle",
                "user_properties",
                "openAdultPop"
            ],

            get() {
                function startsWith(string, search, pos) {
                    pos = !pos || pos < 0 ? 0 : +pos;
                    return string.substring(pos, pos + search.length) === search;
                }
                // 재귀 파싱 함수
                function parseValue(value, deps) {
                    try {
                        // JSON.parse를 시도했을 때, string이 아닌 경우에는 그대로 반환
                        // JSON 형식의 string도 아닐 것이므로 더 이상 파싱할 필요가 없음
                        if (typeof value !== "string") {
                            return value;
                        }

                        // deps가 1이고, 더블 코트를 포함하고 있는 경우,
                        // object-like string (예시 {"a": 1, "b": 2})이 아닌 경우
                        // JSON.parse를 시도하지 않고 그대로 반환
                        if (deps === 1 && value.includes('"') && !startsWith(value, "{") && !startsWith(value, "[")) {
                            return value;
                        }

                        var parsed = JSON.parse(value);

                        if (typeof parsed === 'object' && parsed !== null) {
                            for (var key in parsed) {
                                if (parsed.hasOwnProperty(key)) {
                                    parsed[key] = parseValue(parsed[key], deps + 1);
                                }
                            }
                        }

                        return parsed;
                    } catch (e) {
                        // JSON.parse에 실패한 경우, 그대로 반환
                        // 실패하는 경우 : "true", "123" 과 같은 특정 자료형을 나타내는 문자열이 아닌 일반 문자열 (예시 'W CARE | 올리브영', 'http://localhost:3000/m/mtn/wcare')

                        return value;
                    }
                }

                var keyValues = {};

                for (var i = 0; i < this.keys.length; i++) {
                    var key = this.keys[i]

                    if (sessionStorage.getItem(key) !== null) {
                        var value = sessionStorage.getItem(key);
                        keyValues[key] = parseValue(value, 1);
                    }
                }

                return JSON.stringify(keyValues);
            },

            set(keyValueString) {
                if (typeof keyValueString !== 'string') {
                    this.sendLog('Invalid parameter type', keyValueString, 'warn');

                    return;
                }

                var excludeKeys = ["gtmPreviousTitle"];

                var keyValues

                try {
                    keyValues = JSON.parse(keyValueString);
                } catch {
                    this.sendLog('Invalid JSON string', keyValueString, 'warn');

                    return;
                }


                try {
                    for (i = 0; i < this.keys.length; i++) {
                        var key = this.keys[i];

                        if (keyValues.hasOwnProperty(key) && !excludeKeys.includes(key)) {
                            var value = keyValues[key];

                            if (typeof value === 'string') {
                                sessionStorage.setItem(key, value);
                            } else {
                                sessionStorage.setItem(key, JSON.stringify(value));
                            }
                        }
                    }
                }
                catch (e) {
                    this.sendLog(`Failed to set session storage item: ${e}`, keyValueString, 'warn');
                }

                return true;
            },
            sendLog(errorLog, keyValueString, errorLevel) {
                let userAgent = navigator.userAgent.replace(/deviceId\/\S+/, '');
                keyValueString = keyValueString && keyValueString.replace(/,?"todayDeliveryAddressList":\[[^\]]*]/, '');
                errorLog = "sessionStorage set(classic)" + errorLog + ", keyValueString: " + keyValueString + ", userAgent: " + userAgent;

                fetch('/m/app/log.do', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        level: errorLevel,
                        logMessage: encodeURIComponent(errorLog)
                    })
                });
            }
        };
    },


    /**
     * user agent 초기화 
     */
    init : function() {
        this.parser = new UserAgentUtil(navigator.userAgent);
        this.appInfo = this.parser.getAppInfo();
        
//        if (false && this.appInfo.isapp) {
//            $(document).bind("touchstart", function() {
//               
//                if (common.app.scrollInterval != null) {
//                    clearInterval(common.app.scrollInterval);
//                }
//                
//                common.app.scrollInterval = setInterval(function() {
//                   common.app.scroll();
//               }, 100); 
//            });
//            
//            $(document).bind("touchend", function() {
//                setTimeout(function() {
//                    clearInterval(common.app.scrollInterval); 
//                    common.app.scrollInterval = null;
//                }, 1000);
//                
//            });
//        } 
        $("#contactInfoBtn").on("click",function(){
            var isVer = common.app.appInfo.appver.replace(/\./gi, "");
            var isOS  = common.app.appInfo.ostype;
            
            /* ios는 10, android는 20 주소록 없는 구버전은 앱다운로드 유도 */
            if ((isOS == "10" && parseInt(isVer) < 224)) {
                if(confirm("최신버전 앱으로 업데이트하고\n연락처를 편하게 입력해보세요.")){
                    common.app.callOpenBrowser("https://itunes.apple.com/kr/app/ollibeuyeong/id873779010?l=kr&mt=8");
                }
                
            }else if((isOS == "20" && parseInt(isVer) < 222)){
                if(confirm("최신버전 앱으로 업데이트하고\n연락처를 편하게 입력해보세요.")){
                    common.app.callOpenBrowser("oliveyoungapp://openBrowser?url=market://details?id=com.oliveyoung");
                }

            } else {
                if (window.App
                    && window.App.getContactInfo) {
                    window.App.getContactInfo();
                } else if (window.webkit
                    && window.webkit.messageHandlers
                    && window.webkit.messageHandlers.getContactInfo) {
                    var encodedParams = encodeURIComponent(JSON.stringify({
                        getContactInfo: "true",
                    }));

                    window.webkit.messageHandlers.getContactInfo.postMessage({params: encodedParams});
                } else {
                    location.href = "oliveyoungapp://getContactInfo";
                }
            }
        });

        common.app.initAppInterface();
        common.app.setSessionStorageBridge();
    },

    initAppInterface : function() {
        if(common.app.isMessageEventSet) {
            return;
        }

        common.app.isMessageEventSet = true;
        window.addEventListener('message', function(event) {
            if(!event || !event.data || !event.data.target) {
                return;
            }
            const eventName = event.data.target;
            switch(eventName) {
                case 'toggleNavigationDrawer' :
                    common.link.moveNavigationPage("category");
                    break;
                case 'openSearch':
                    common.header.openSearch();
                    break;
            }
        });
    },
    /**
     * 0105. APP_앱설정화면호출_송신
     */
    callSettings : function() {
        if (!common.app.appInfo.isapp) {
            return;
        }

        // 바이오 로그인 삭제 브레이즈
        // http://cjics.cj.net/jira/browse/CJOYCOMM-1342
        try {
            var brazeEventName;
            if(common.app.compareVersion(common.app.appInfo.appver, "3.1.0") ==  "<") {
                brazeEventName = 'OY_bioout_old';
            } else {
                brazeEventName = 'OY_bioout_new';
            }

            common.callBrazeCustomEvent(brazeEventName, {});
        } catch(_) {
            void 0
        }

        if (window.App
            && window.App.settings) {
            window.App.settings();
            return;
        }

        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.settings) {
            var encodedParams = encodeURIComponent(JSON.stringify({
                settings: "true",
            }));

            window.webkit.messageHandlers.settings.postMessage({params: encodedParams});
            return;
        }

        location.href = "oliveyoungapp://settings";
    },
    
    /**
     * 0106. APP_로그인_송신
     */
    callLoginInfo : function(loginYn, loginId, ssoMbrNo, strNtcRcvAgrYn, mblEventAgrYn, callPushAgrYn, closeYn, custInfo, bioPopHide, touchIdLoginYn, biometricsUseYn, referer, isAppver, encMbrNo, mbrNo, isUnder14) {
        if (!common.app.appInfo.isapp) {
            return;
        }

        var appInfoParams = {
            loginYn: loginYn,
            loginId: loginId,
            ssoMbrNo: ssoMbrNo,
            strNtcRcvAgrYn: strNtcRcvAgrYn,
            mblEventAgrYn: mblEventAgrYn,
            callPushAgrYn: callPushAgrYn,
            closeYn: closeYn,
            custInfo: common.app.fixedEncodeURIComponent(custInfo),
            bioPopHide: bioPopHide,
            touchIdLoginYn: touchIdLoginYn,
            biometricsUseYn: biometricsUseYn,
            encMbrNo: encMbrNo,
            mbrNo: mbrNo, // 온라인몰 member number (Mxxxx...)
        };
        // getParameterString 은 undefined 를 "undefined" 로 붙이므로 boolean 일 때만 싣는다
        if (typeof isUnder14 === "boolean") {
            appInfoParams.isUnder14 = isUnder14;
        }

        if(isAppver == "Y"){
            appInfoParams.movePage = common.app.fixedEncodeURIComponent(referer);
            location.href = "oliveyoungapp://loginInfo?" + common.getParameterString(appInfoParams);
        }else{
            location.href = "oliveyoungapp://loginInfo?" + common.getParameterString(appInfoParams);
        }
    },
    
    /**
     * 0107. APP_로그아웃_송신
     */
    callLogout : function() {
        if (!common.app.appInfo.isapp) {
            return;
        }

        if (window.App
            && window.App.logout) {
            window.App.logout();
            return;
        }

        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.logout) {
            var encodedParams = encodeURIComponent(JSON.stringify({
                logout: "true",
            }));

            window.webkit.messageHandlers.logout.postMessage({params: encodedParams});
            return;
        }

        location.href = "oliveyoungapp://logout";
    },
    
    /**
     * 0108. APP_외부브라우저_실행_송신
     */
    callOpenBrowser : function(url) {
        if (common.app.appInfo.isapp) {
            if (window.App
                && window.App.openBrowser) {
                window.App.openBrowser(JSON.stringify({ url: url }));
                return;
            }

            if (window.webkit
                && window.webkit.messageHandlers
                && window.webkit.messageHandlers.openBrowser) {
                window.webkit.messageHandlers.openBrowser.postMessage({ params: JSON.stringify({ url: url }) });
                return;
            }

            location.href = "oliveyoungapp://openBrowser?url=" + common.app.fixedEncodeURIComponent(url);
        } else {
            window.open(url);
        }
    },
    
    /**
     * 0109. APP_업로드_이미지선택_송신
     */
    callImgSelector : function() {
        if (!common.app.appInfo.isapp) {
            return;
        }

        if (window.App
            && window.App.imageSelector) {
            window.App.imageSelector();
            return;
        }

        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.imageSelector) {
            var encodedParams = encodeURIComponent(JSON.stringify({
                imageSelector: "true",
            }));

            window.webkit.messageHandlers.imageSelector.postMessage({params: encodedParams});
            return;
        }

        location.href = "oliveyoungapp://imageSelector";

    },
    
    /**
     * 0110. APP_업로드_이미지선택_결과_수신
     */
    setUploadImgBase64 : function(fileName, fileBase64) {
        if (common.app.appInfo.isapp) {
            this.callbackUploadImgBase64(fileName, fileBase64);
        }
    },
    
    /**
     * 이미지 업로드 결과 수신 콜백 - 개발 페이지에 override 구현
     */
    callbackUploadImgBase64 : function(fileName, fileBase64) {
        
    },
    
    /**
     * 0111. APP_URL링크_이동_송신
     */
    callOpenPage : function(title, url, closeYn, isGet, isBack) {
        if (common.app.appInfo.isapp) {
            closeYn = common.isEmpty(closeYn) ? "N" : closeYn;
            isGet = common.isEmpty(isGet) ? "N" : isGet;
            isBack = common.isEmpty(isBack) ? "N" : isBack;

            var pageParams = {
                title: title,
                url: url,
                closeYn: closeYn,
                isGet: isGet,
                isBack: isBack,
            }

            if (window.App
                && window.App.openPage) {
                window.App.openPage(JSON.stringify(pageParams));
            } else if (window.webkit
                && window.webkit.messageHandlers
                && window.webkit.messageHandlers.openPage) {
                var encodedParams = encodeURIComponent(JSON.stringify(pageParams));
                window.webkit.messageHandlers.openPage.postMessage({params: encodedParams});
            } else {
            location.href = "oliveyoungapp://openPage?" 
                + "title=" + common.app.fixedEncodeURIComponent(title) 
                + "&url=" + common.app.fixedEncodeURIComponent(url) 
                + "&closeYn="+common.app.fixedEncodeURIComponent(closeYn) 
                + "&isGet=" + common.app.fixedEncodeURIComponent(isGet) 
                + "&isBack=" + common.app.fixedEncodeURIComponent(isBack);
            }
        }else{
            window.open(url);
        }        
    },

    /**
     * openPage 오류를 대체한 openWebScreen 사용을 위한 메서드
     * @param - screenType: modal, fullscreenmodal
     * @param - method: get, post
     * @see - https://oyitsm.cj.net/confluence/pages/viewpage.action?pageId=371526728
     */
    callOpenWebScreen: function({ title, url, screenType="fullscreenmodal", method="get", ...arg }) {
        // 앱이 아닌 경우
        if (!common.app.appInfo.isapp) {
            window.open(url);
            return;
        }

        // 앱버전이 낮아 openWebScreen 인터페이스가 존재하지 않는 경우
        if (common.app.compareVersion(common.app.appInfo.appver, "3.16.0") ==  "<") {
            const { closeYn, isGet, isBack } = arg; // 구조분해 할당이 es6 문법이라 argument[0]가 아닌 스프레드 연산자를 사용하였습니다

            common.app.callOpenPage(title, url, closeYn, isGet, isBack);

            return;
        }

        const stringTypeJsonParams = JSON.stringify({
            title,
            url,
            method,
            transition: screenType,
        });

        const isExistOpenWebScreenOnAos = window.App && window.App.openWebScreen;
        const isExistOpenWebScreenOnIos = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openWebScreen;

        if (isExistOpenWebScreenOnAos) {
            // AOS
            window.App.openWebScreen(stringTypeJsonParams);

            return;
        } else if (isExistOpenWebScreenOnIos) {
            // IOS
            window.webkit.messageHandlers.openWebScreen.postMessage({
                params: stringTypeJsonParams,
            });

            return;
        }

        // 앱인터페이스가 없는 케이스 방어코드
        window.open(url);
    },

    /**
     * 0113. APP_로딩바_송신
     */
    callShowLoadingBar : function(showYn) {
        if (!common.app.appInfo.isapp) {
            return;
        }

        if (window.App
            && window.App.showLoadingBar) {
            window.App.showLoadingBar(JSON.stringify({ showYn: showYn }));
            return;
        }

        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.showLoadingBar) {
            var encodedParams = encodeURIComponent(JSON.stringify({ showYn: showYn }));
            window.webkit.messageHandlers.showLoadingBar.postMessage({params: encodedParams});
            return;
        }

        location.href = "oliveyoungapp://showLoadingBar?showYn=" + showYn;
    },
    
    
    /**
     * 0115. APP_웹페이지스크립트호출_송신
     */
    callWebScript : function(scriptNm) {
        if (!common.app.appInfo.isapp) {
            return;
        }

        if (window.App
            && window.App.callWebScript) {
            window.App.callWebScript(JSON.stringify({ script: scriptNm }));
            return;
        }

        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.callWebScript) {
            var encodedParams = encodeURIComponent(JSON.stringify({ script: scriptNm }));
            window.webkit.messageHandlers.callWebScript.postMessage({params: encodedParams});
            return;
        }

        location.href = "oliveyoungapp://callWebScript?script=" + scriptNm;
    },
    
    /**
     * 0114. APP_팝업닫기_송신(deeplink)
     */
    callClosePage : function() {
        if (!common.app.appInfo.isapp) {
            return;
        }

        if (window.App
            && window.App.closePage) {
            window.App.closePage();
            return;
        }

        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.closePage) {
            var encodedParams = encodeURIComponent(JSON.stringify({
                closePage: "true",
            }));

            window.webkit.messageHandlers.closePage.postMessage({params: encodedParams});
            return;
        }

        location.href = "oliveyoungapp://closePage";
    },

    /**
     * [CJOYMS-5874] APP_회원상태변경_지원여부 판별
     * updateMemberState 인터페이스(iOS 3.51.0+ 신규)를 현재 앱이 지원하는지 핸들러 존재 여부로 판별
     */
    isUpdateMemberStateSupported : function() {
        if (!common.app.appInfo.isapp) {
            return false;
        }

        // TODO(CJOYMS-5874): AOS 브릿지 시그니처 앱팀 확정 필요 (슬랙 스펙은 iOS 송신부만 제공)
        var isExistUpdateMemberStateOnAos = !!(window.App && window.App.updateMemberState);
        // callUpdateMemberState 가 실제로 보낼 수 있는 채널과 같은 조건으로 판별한다.
        // auth 채널은 iOS 3.51.0 에서 처음 생길 때부터 updateMemberState 를 처리하므로(3.51~3.57 은 auth 만 존재)
        // 신규 updateMemberState 채널(3.58.0+)만 보면 구버전 앱의 전환 후 linkageString 재조회·화면 정리가 누락된다.
        var isExistUpdateMemberStateOnIos = !!(window.webkit
            && window.webkit.messageHandlers
            && (window.webkit.messageHandlers.updateMemberState
                || window.webkit.messageHandlers.auth));

        return isExistUpdateMemberStateOnAos || isExistUpdateMemberStateOnIos;
    },

    /**
     * [CJOYMS-5874] APP_회원상태변경_송신 (updateMemberState)
     * 임시회원 → CJ ONE 전환 가입 완료 시, 앱이 linkageString 갱신 + 열어 둔 웹뷰 스택 전체를 일괄 정리하고 OY 홈으로 랜딩시키는 신규 인터페이스
     * 주의1: 구버전 앱은 본 인터페이스를 해석하지 못하므로 딥링크 폴백(oliveyoungapp://)을 두지 않는다. 핸들러 부재 시 no-op.
     * 주의2: iOS 신규 앱은 OAuth 토큰 교체용 updateMemberState를 먼저 호출하고, 1초 뒤 기존 auth 채널로 화면 정리를 요청한다.
     *        updateMemberState 핸들러가 없는 구버전 앱은 기존 auth 채널만 즉시 호출한다. AOS 브릿지 시그니처는 앱팀 확정 필요.
     */
    callUpdateMemberState : function() {
        if (!common.app.appInfo.isapp) {
            return;
        }

        // TODO(CJOYMS-5874): AOS 브릿지 시그니처 앱팀 확정 필요 (슬랙 스펙은 iOS 송신부만 제공)
        if (window.App
            && window.App.updateMemberState) {
            window.App.updateMemberState();
            return;
        }

        if (window.webkit && window.webkit.messageHandlers) {
            var messageHandlers = window.webkit.messageHandlers;

            if (messageHandlers.updateMemberState) {
                messageHandlers.updateMemberState.postMessage({});

                if (messageHandlers.auth) {
                    setTimeout(function() {
                        messageHandlers.auth.postMessage({"type":"updateMemberState"});
                    }, 1000);
                }
                return;
            }

            if (messageHandlers.auth) {
                messageHandlers.auth.postMessage({"type":"updateMemberState"});
                return;
            }
        }

        // 구버전 앱: 핸들러 부재 — 신규 인터페이스를 해석하지 못하므로 딥링크 폴백 없이 종료 (호출부에서 isUpdateMemberStateSupported로 사전 분기)
    },

    /**
     * [CJOYMS-5655] APP_회원상태변경(토큰 교체 전용)_지원여부 판별
     * TEMP_MERGE direct path(Gate 3/4)용 — 신규 oAuth 채널(updateMemberState) 자체의 존재를 확인한다.
     * AOS(window.App)까지 함께 판별하는 isUpdateMemberStateSupported와 달리 iOS 신규 채널만 확인한다.
     */
    isUpdateMemberStateTokenOnlySupported : function() {
        if (!common.app.appInfo.isapp) {
            return false;
        }

        // TODO(CJOYMS-5874): AOS는 member-conversion 수신 규약 미구현 — 앱팀 확정 시 추가
        return !!(window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.updateMemberState);
    },

    /**
     * [CJOYMS-5655] APP_회원상태변경(토큰 교체 전용)_송신
     * 신규 oAuth 채널만 발사한다. 레거시 auth 채널(웹뷰 스택 전체 종료 + 홈 랜딩)을 쏘지 않으므로
     * 현재 화면을 유지해야 하는 지면(비밀번호 변경 권고 등)에서 안전하다.
     * 핸들러 부재 시 no-op (구버전 앱/모바일웹 — 딥링크 폴백 없음).
     * 중복 발사는 무해: 인가서버가 CONVERTED one-shot 소비 + CONSUMED 60초 멱등 replay로 처리한다.
     */
    callUpdateMemberStateTokenOnly : function() {
        if (!common.app.isUpdateMemberStateTokenOnlySupported()) {
            return;
        }

        window.webkit.messageHandlers.updateMemberState.postMessage({});
    },

    /**
     * 0114. APP_로그아웃요청_수신(javascript)
     */
    logout : function() {
        //로그아웃
        if (common.app.appInfo.isapp) {
            common.link.moveLogoutPage('앱드로워'); // 실제로는 수행되지 않음을 확인
        }
    },

    /**
     * 0113. APP_슬라이드메뉴노출여부_송신(deeplink)
     * @param {string} showYn: Y/N
     * @param {number} delay: 0이상 정수 / -1 setTimeout 타이머 없이 호출
     * @returns
     */
    callMenu : function(showYn, delay = -1) {
        if (!common.app.appInfo.isapp) {
            return;
        }

        if (window.App
            && window.App.menu) {
            window.App.menu(JSON.stringify({ showYn: showYn }));
            return;
        }

        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.menu) {
            var encodedParams = encodeURIComponent(JSON.stringify({ showYn: showYn }));
            window.webkit.messageHandlers.menu.postMessage({params: encodedParams});
            return;
        }

        if (delay === -1) {
            location.href = "oliveyoungapp://menu?showYn=" + showYn;
        } else {
            setTimeout(function () {
                location.href = "oliveyoungapp://menu?showYn=" + showYn;
            }, delay);
        }
    },

	/**
     * 0121. APP_페이지이동
     */
    callMovePage : function(url) {
        // iOS의 경우 앱에서 custom scheme 호출시 이동 안되는 현상으로 인해 앱은 화면 이동으로 변경
        if (common.app.appInfo.isapp) {
            location.href = url;
        } else {
            location.href = "oliveyoungapp://movePage?af_dp=&url=" + common.app.fixedEncodeURIComponent(url);
        }
    },

    /**
     * 0124. APP_웹페이지스크립트호출_송신
     */
    callWebUrl : function(url) {
        if (!common.app.appInfo.isapp) {
            return;
        }

        if (window.App
            && window.App.callWebUrl) {
            window.App.callWebUrl(JSON.stringify({ url: url }));
            return;
        }

        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.callWebUrl) {
            var encodedParams = encodeURIComponent(JSON.stringify({ url: url }));
            window.webkit.messageHandlers.callWebUrl.postMessage({params: encodedParams});
            return;
        }

        location.href = "oliveyoungapp://callWebUrl?url=" + common.app.fixedEncodeURIComponent(url);
    },
    
    /**
     * 0125. APP_팝업닫음(설정에서 로그인 관련 팝업 처리 용도)
     */
    callClosePopup : function() {
        if (!common.app.appInfo.isapp) {
            return;
        }

        if (window.App
            && window.App.closePopup) {
            window.App.closePopup();
            return;
        }

        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.closePopup) {
            var encodedParams = encodeURIComponent(JSON.stringify({
                closePopup: "true",
            }));

            window.webkit.messageHandlers.closePopup.postMessage({params: encodedParams});
            return;
        }

        location.href = "oliveyoungapp://closePopup";
    },

    //타이틀, 파라미터 인코딩
    fixedEncodeURIComponent : function(str) {
        return encodeURIComponent(str).replace(/[!'()]/g, escape).replace(/\*/g, "%2A");
    },
    
    /**
     * 에러 시 APP_팝업닫음(설정에서 로그인 관련 팝업 처리 용도)
     */
    callCloseErrPopup : function() {
        if (common.app.appInfo.isapp) {
            if (window.App
                && window.App.closePopup) {
                window.App.closePopup();
            } else if (window.webkit
                && window.webkit.messageHandlers
                && window.webkit.messageHandlers.closePopup) {
                var encodedParams = encodeURIComponent(JSON.stringify({
                    closePopup: "true",
                }));

                window.webkit.messageHandlers.closePopup.postMessage({params: encodedParams});
            } else {
                setTimeout(function() {
                    location.href = "oliveyoungapp://closePopup";
                }, 50);
            }
        }
        
        setTimeout(function() {
            history.back();
        }, 300);
    },

    /**
     * 앱에서 custInfo(자동로그인)쿠키 삭제시 필요
     */
    callDeleteCustInfo : function(){
        if (!common.app.appInfo.isapp) {
            return;
        }

        if (window.App
            && window.App.deleteCustInfo) {
            window.App.deleteCustInfo();
            return;
        }

        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.deleteCustInfo) {
            var encodedParams = encodeURIComponent(JSON.stringify({
                deleteCustInfo: "true",
            }));

            window.webkit.messageHandlers.deleteCustInfo.postMessage({params: encodedParams});
            return;
        }

        setTimeout(function() {
            location.href = "oliveyoungapp://deleteCustInfo";
        }, 200);
    },

    callGeoLocationSettings: function() {
        if (!common.app.appInfo.isapp) {
            return;
        }

        if (window.App
            && window.App.getLocationSettings) {
            window.App.getLocationSettings();
            return;
        }

        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.getLocationSettings) {
            var encodedParams = encodeURIComponent(JSON.stringify({
                getLocationSettings: "true",
            }));

            window.webkit.messageHandlers.getLocationSettings.postMessage({params: encodedParams});
            return;
        }

        location.href = "oliveyoungapp://getLocationSettings";
    },

    scroll : function() {
        //$(document).scroll();
//        console.log("스크롤이벤트 호출됨");
    },
    
    /**
     *  앱 버전 비교
     */
    compareVersion : function(v1, v2) {
 
        var rtn;
        v1_array = v1.split('.');
        v2_array = v2.split('.');

        if(v1 == v2){
            rtn =  "=";
        }else{
            for(var x=0;x<v1_array.length;x++){
                if (Number(v1_array[x]) < Number(v2_array[x])){
                    rtn =  "<";
                    break;
                }
                
                if(Number(v1_array[x]) > Number(v2_array[x])){
                    rtn =  ">";
                    break;
                }
            }
        }
        return rtn;
    },
    
    /**
     * 네이티브 화면 제어 브릿지 (앱 3.51.0 이상)
     * 모듈/스코프 단위 인터페이스. iOS/Android 핸들러명: nativeScreen
     */
    nativeScreen : {
        MIN_VERSION : "3.51.0",
        /** 3.51.0 이상 앱에서만 지원 */
        isSupported : function() {
            var info = common.app.appInfo;
            if (!info || !info.isapp || !info.appver) {
                return false;
            }
            return common.app.compareVersion(info.appver, this.MIN_VERSION) !== "<";
        },
        /** 플랫폼별 전송 (iOS: 객체 / Android: 문자열) */
        _post : function(message) {
            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeScreen) {
                window.webkit.messageHandlers.nativeScreen.postMessage(message);
                return true;
            }
            if (window.nativeScreen && typeof window.nativeScreen.postMessage === "function") {
                window.nativeScreen.postMessage(JSON.stringify(message));
                return true;
            }
            return false;
        },
        /** 새 웹뷰 push */
        pushScreen : function(url) {
            return this._post({ type: "pushScreen", payload: { url: url } });
        },
        /** 현재 화면 pop */
        popScreen : function() {
            return this._post({ type: "popScreen", payload: {} });
        },
        /** 뒤로가기(없으면 pop) */
        goBack : function() {
            return this._post({ type: "goBack", payload: {} });
        }
    },

    /**
     *  OS 버전 비교
     */
    compareVersion2 : function(v1, v2) {
 
        var rtn;
        v1_array = v1.split('.');
        v2_array = v2.split('.');
        
        var array_length = 0;
        var ver1 = "";
        var ver2 = "";
        
        if(v1_array.length > v2_array.length){
            array_length = v1_array.length;
        }else{
            array_length = v2_array.length;
        }
        
        for(var x=0;x<array_length;x++){
            
            if(common.isEmpty(v1_array[x])){
                ver1 = 0;
            }else{
                ver1 = Number(v1_array[x]);
            }
            
            if(common.isEmpty(v2_array[x])){
                ver2 = 0;
            }else{
                ver2 = Number(v2_array[x]);
            }
            
            if(ver1 < ver2){
                rtn =  "<";
                break;
            }
            
            if(ver1 > ver2){
                rtn =  ">";
                break;
            }
        }
        
        if(common.isEmpty(rtn)){
            rtn =  "=";
        }
        
        return rtn;
    },
    
    /**
     * CJONE에서 스마트영수증 팝업 닫을 경우 호출하는 스킴
     */
    callCjoneClose : function() {
        setTimeout(function() {
            location.href = "cjonecard://webtoapp?action=smart_receipt_action&type=confirm";
        }, 100);
    },

    /**
     * Firebase interface
     * http://cjics.cj.net/jira/browse/CJOYCOMM-60
     */
    // WebView 내에서 발생되는 Custom Event 데이터를 Native 영역으로 보내는 함수
    sendEventForFirebase : function(name, params) {
        if (!name) {
            return;
        }
        if (window.AnalyticsWebInterface) {
            // Android Interface가 불리는 영역
            window.AnalyticsWebInterface.logEvent(name, JSON.stringify(params));
        } else if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.firebase) {
            //iOS Interface가 불리는 영역
            var message = {
                command: 'logEvent',
                name: name,
                parameters: params
            };
            window.webkit.messageHandlers.firebase.postMessage(message);
        }else{
            window.dataLayer.push({event : name, parameters: params});
        }
    },

    sendWishEventForFirebase: function(gtmInfo) {
        var categoryArray = gtmInfo.stdCatNm.split('>');
        var price = Number(gtmInfo.salePrc);
        common.app.sendEventForFirebase('add_to_wishlist', {
            currency: "KRW",
            lgc_goods_no: gtmInfo.lgcGoodsNo,
            items: [{
                item_id: gtmInfo.goodsNo,
                item_name: gtmInfo.goodsNm,
                currency: "KRW",
                item_category: categoryArray[0],
                item_category2: categoryArray[1],
                item_category3: categoryArray[2],
                price: price
            }]
        });
    },

    /**
     * APP interface 통신 공통함수
     */
    sendAppInterface: function(aosFunc1, aosFunc2, iosFunc, encodedParams, callback) {
        if(!encodedParams) return;

        // Android Interface가 불리는 영역
        if (window[aosFunc1]
            && window[aosFunc1][aosFunc2]) {
            window[aosFunc1][aosFunc2](encodedParams);
            return true;
        }

        //iOS Interface가 불리는 영역
        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers[iosFunc]) {
            window.webkit.messageHandlers[iosFunc].postMessage({params: encodedParams});
            return true;
        }

        // Android & iOS Interface가 없을경우
        if(callback) callback();
        return false;
    },

    /**
     * Braze interface
     */
    sendCustomEventForBraze: function(params) {
        if (!params) return;
        var encodedParams = encodeURIComponent(JSON.stringify(params));

        var aosFuncNm1 = "Braze";
        var aosFuncNm2 = "customEvent";
        var iosFuncNm = "brazeCustomEvent";

        this.sendAppInterface(
            aosFuncNm1,
            aosFuncNm2,
            iosFuncNm,
            encodedParams,
            function() {
                location.href = "oliveyoungapp://sendBrazeCustomEventParam?param=" + encodedParams;
        });
    },


    addCustomAttributeForBraze: function(attributeName, attributeValue) {
        if (!attributeName || attributeValue === null) return;
        var encodedParams = encodeURIComponent(JSON.stringify({
            key: attributeName,
            value: attributeValue,
        }));

        var aosFuncNm1 = "Braze";
        var aosFuncNm2 = "addCustomAttribute";
        var iosFuncNm = "brazeAddCustomAttribute";

        this.sendAppInterface(
            aosFuncNm1,
            aosFuncNm2,
            iosFuncNm,
            encodedParams);
    },

    setCustomAttributeForBraze: function(attributeName, attributeValue) {
        if (!attributeName || attributeValue === null) return;
        var encodedParams = encodeURIComponent(JSON.stringify({
            key: attributeName,
            value: attributeValue,
        }));

        var aosFuncNm1 = "Braze";
        var aosFuncNm2 = "setCustomAttribute";
        var iosFuncNm = "brazeSetCustomAttribute";

        this.sendAppInterface(
            aosFuncNm1,
            aosFuncNm2,
            iosFuncNm,
            encodedParams);
    },

    sendPurchaseEventForBraze: function(productId, price, quantity, params) {
        if(!params) return;
        var sendParams = {
            productId,
            price,
            quantity,
            ...params,
        }
        var encodedSendParams = encodeURIComponent(JSON.stringify(sendParams));

        var aosFuncNm1 = "Braze";
        var aosFuncNm2 = "purchaseEvent";
        var iosFuncNm = "brazePurchaseEvent";

        this.sendAppInterface(
            aosFuncNm1,
            aosFuncNm2,
            iosFuncNm,
            encodedSendParams,
            function() {
                location.href = 'oliveyoungapp://sendBrazePurchaseEventParam?productId=' + productId
                    + '&price=' + price
                    + '&quantity=' + quantity
                    + '&param=' + encodedSendParams;
        });
    },

    /**
     * Event Tracking
     */
    sendEventTracking: function(eventName, property) {
        if (!eventName) {
            void 0;
            return false;
        }

        if (!common.app.appInfo.isapp) {
            return false;
        }

        const appEventValues = {
            event_type: eventName,
            event_properties: property,
            url: location.href,
        };

        if(property.log_channel === "oy"){
            if (window.App && window.App.logOYEvent) {
                window.App.logOYEvent(encodeURIComponent(JSON.stringify(appEventValues)));

                return true;
            }

            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.logOYEvent) {
                window.webkit.messageHandlers.logOYEvent.postMessage({
                    params: encodeURIComponent(JSON.stringify(appEventValues)),
                });

                return true;
            }
        } else{
            if (window.App && window.App.trackEvent) {
                window.App.trackEvent(encodeURIComponent(JSON.stringify(appEventValues)));

                return true;
            }

            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.appTrackEvent) {
                window.webkit.messageHandlers.appTrackEvent.postMessage({
                    params: encodeURIComponent(JSON.stringify(appEventValues)),
                });

                return true;
            }
        }

        return false;
    },

    sendAppBarcodeToggleYn: function(barcodeToggleCkYn) {
        var encodedParams = encodeURIComponent(JSON.stringify({
            isOn: barcodeToggleCkYn
        }));

        var aosFuncNm1 = "App";
        var aosFuncNm2 = "openShakeMembership";
        var iosFuncNm = "AppOpenShakeMembership";

        this.sendAppInterface(
            aosFuncNm1,
            aosFuncNm2,
            iosFuncNm,
            encodedParams);
    },

    sendAutoMaxBrightnessOnShake: function(maxBrightnessYn) {
        var encodedParams = encodeURIComponent(JSON.stringify({
            isOn: maxBrightnessYn
        }));

        var aosFuncNm1 = "App";
        var aosFuncNm2 = "autoMaxBrightnessOnShake";
        var iosFuncNm = "autoMaxBrightnessOnShake"

        this.sendAppInterface(
            aosFuncNm1,
            aosFuncNm2,
            iosFuncNm,
            encodedParams
        );
    },

    sendBarcodeToggleStatus: function() {
        var encodedParams = encodeURIComponent(JSON.stringify({}));

        var aosFuncNm1 = "App";
        var aosFuncNm2 = "getShakeBarcodeToggleState";
        var iosFuncNm = "getShakeBarcodeToggleState";

        this.sendAppInterface(
            aosFuncNm1,
            aosFuncNm2,
            iosFuncNm,
            encodedParams);
    },

    sendAppSnsShareEvent: function(title, linkUrl) {
        if(!title || !linkUrl) return false;
        var encodedParams = encodeURIComponent(JSON.stringify({
            snsText: title + "\n" + linkUrl,
        }));

        var aosFuncNm1 = "App";
        var aosFuncNm2 = "share";
        var iosFuncNm = "AppShare";

        return this.sendAppInterface(
            aosFuncNm1,
            aosFuncNm2,
            iosFuncNm,
            encodedParams);
    },

    sendAppScanBarcodeEvent: function() {
        // Android Interface가 불리는 영역
        if (window.App
            && window.App.scanBarcode) {
            window.App.scanBarcode();
            return;
        }

        //iOS Interface가 불리는 영역
        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.scanBarcode) {
            var encodedParams = encodeURIComponent(JSON.stringify({
                scanbarcodeYn: "true",
            }));
            window.webkit.messageHandlers.scanBarcode.postMessage({params: encodedParams});
            return;
        }

        location.href = "oliveyoungapp://scanBarcode";
    },

    /**
     * AppsFlyer trackEvent Interface
     */
    sendAppsFlyerEvent: function(inputEventName, eventValue) {
        var encodedParams = encodeURIComponent(JSON.stringify(eventValue));

        // Android Interface가 불리는 영역
        if (window.Appsflyer
            && window.Appsflyer.logEvent) {
            window.Appsflyer.logEvent(inputEventName, encodedParams);
            return;
        }

        //iOS Interface가 불리는 영역
        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.appsflyerEvent) {
            window.webkit.messageHandlers.appsflyerEvent.postMessage({
                eventName: inputEventName,
                eventValue: encodedParams,
            });
            return;
        }

        location.href = "oliveyoungapp-af-event://?eventName=" + inputEventName
            + "&eventValue=" + common.app.fixedEncodeURIComponent(JSON.stringify(eventValue));
    },

    /**
     * enablePullToRefresh Interface : 당겨서 새로고침 활성 / 비활성화 제어
     * @param {string} isEnabled: Y: 당겨서 새로고침 활성화 / N: 당겨서 새로고침 비활성화
     */
    sendAppEnablePullToRefresh : function (isEnabled) {
        if(!isEnabled) return;

        var params = JSON.stringify({
                isEnabled: isEnabled
        });

        // iOS일 때만 인코딩해서 전달
        if(common.app.appInfo.ostype == common.app.IOS_TYPE) {
            params = encodeURIComponent(params);
        }

        var aosFuncNm1 = "App";
        var aosFuncNm2 = "enablePullToRefresh";
        var iosFuncNm = "enablePullToRefresh";

        this.sendAppInterface(
            aosFuncNm1,
            aosFuncNm2,
            iosFuncNm,
            params);
        
    },

    /**
     * AppsFlyer trackEvent 호출하는 함수
     */
    callTrackEvent : function(eventType, eventValue) {
        var eventName = eventType;
        if("gnb" === eventName) eventName = "af_gnb";
        if("category" === eventName) eventName = "af_category";
        if("search" === eventName) eventName = "af_search";
        if("goods" === eventName) eventName = "af_goods_detail";
        if("cart" === eventName) eventName = "af_add_to_cart";
        if("login" === eventName) eventName = "af_login";

        if (common.app.appInfo.isapp) {
            if(common.app.compareVersion(common.app.appInfo.appver, "2.0.8") ==  ">"){
                common.app.sendAppsFlyerEvent(eventName, eventValue);
            }
        }
    },

    /**
     * LiveNudge App Interface 호출
     */

    setLiveNudgeClose: function() {
        $('#fixBtn').removeClass('live');
        $('#alwaysOnFixBtn').removeClass('onLive');
        sessionStorage.setItem("liveNudgeSkip", "Y");
    },

    /**
     * eventType: 'RGR', 'ODR'
     * options
     *  - goodsNm: 주문 상품명(복수일 경우 ';'로 연결)
     *  - quantity: 주문 수량(복수일 경우 ';'로 연결)
     *  - price: 주문 금액(복수일 경우 ';'로 연결)
     *  - orderNm: 주문 번호
     */
    sendEventForTBase : function(eventType, options) {
        // if(!eventType || !_dbase_n) {
        //     return;
        // }
        // _TRK_PI = eventType;
        // if(options){
        //     if(options.goodsNm) _TRK_OP = options.goodsNm;
        //     if(options.quantity) _TRK_OE = options.quantity;
        //     if(options.price) _TRK_OA = options.price;
        //     if(options.orderNm) _TRK_ODN = options.orderNm;
        // }else{
        //     _TRK_OP = '';
        //     _TRK_OE = '';
        //     _TRK_OA = '';
        //     _TRK_ODN = '';
        // }
        // _dbase_n('1109','conv');
    },

    /**
     * ios post send 데이타를 받아 post send 
     */
    appPostSndBridge : function(path, uParams, method) {
        var params = {};
        
        uParams.split('&').forEach(function(pairs) {
            var pair = {};
            
            if(pairs.indexOf('=') > -1){
                pair[0] = pairs.substring(0, pairs.indexOf('='));
                pair[1] = pairs.substring(pairs.indexOf('=')+1, pairs.length);
            }
            
            if (pair[1] !== undefined) {
                var key = decodeURIComponent(pair[0]),
                val = decodeURIComponent(pair[1]);
                //val = val ? val.replace(/\++/g,' ').trim() : '';
                
                if (key.length === 0) {
                    return;
                }
                if (params[key] === undefined) {
                    params[key] = val;
                }
                else {
                    if ("function" !== typeof params[key].push) {
                        params[key] = [params[key]];
                    }
                    params[key].push(val);
                }
            }
        });
        
        var form = document.createElement("form");
        form.setAttribute("id", "payForm");
        form.setAttribute("method", "post");
        form.setAttribute("action", path);
        
        
    
        for(var key in params) {
            if(params.hasOwnProperty(key)) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", params[key]);

                form.appendChild(hiddenField);
            }
        }
        document.body.appendChild(form);
        form.submit();
    },
    
    /**
     * 쿠키 get 
     */
    getCookie : function (c_name) {
        var i,x,y,ARRcookies=document.cookie.split(";");
        
        for (i=0;i<ARRcookies.length;i++){
            x=ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
            y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
            x=x.replace(/^\s+|\s+$/g,"");
            if (x==c_name){
                return unescape(y);
            }
        }
    },

    /**
     * 바이오인증
     * 인터페이스 또는 스킴 호출하면
     * 앱에서 loginForm.jsp 내 구현된 setBioLoginResult 함수를 호출하고 Y/N을 파라미터로 넣어줌
     */
    biometricShow : function(p) {
        if (common.app.appInfo.isapp) {
        	/** 2022-10-26 바이오 로그인 인증 제거 */
        	// location.href = "oliveyoungapp://bioLogin?loginId=" + p;
        }
    },
    
    /**
     * 바이오인증 가능 단말기 확인
     * 인터페이스 또는 스킴 호출하면
     * 앱에서는 loginForm.jsp 내 구현된 setSupportedBioLogin 함수를 호출하고 Y/N을 파라미터로 넣어줌
     */
    biometricCheck : function() {
        if (common.app.appInfo.isapp) {
        	/** 2022-10-26 바이오 로그인 인증 제거 */
            // location.href = "oliveyoungapp://isSupportedBioLogin";
        }
    },
    
    //바이오인증 정보 초기화
    callReSetBiometrics : function() {
        if (common.app.appInfo.isapp) {
        	/** 2022-10-26 바이오 로그인 인증 제거 */
            // location.href = "oliveyoungapp://resetBiometrics";
        }
    },
    
    // 푸시 리스트 new 여부
    setPushMsgNewYn : function(newYn){
        // 새로운 푸시 알림 있는지 확인 후 new 표시해준다.
        if(newYn == 'Y'){
            $(".notice").html("<em>N</em>알림");
        }else{
            $(".notice").html("알림");
        }
    },
    
    // 푸시 수신 동의 팝업 요청(바이오 로그인 팝업을 닫을때 or 바이오 로그인 팝업 띄우지 않을때 호출)
    callBioLoginAgrCallBack : function() {
        if (!common.app.appInfo.isapp) {
            return;
        }

        var isVer = common.app.appInfo.appver.replace(/\./gi, "");
        var isOS  = common.app.appInfo.ostype;
        if ((isOS == "10" && parseInt(isVer) >= 218) || (isOS == "20" && parseInt(isVer) >= 216)) {
            location.href = "oliveyoungapp://bioLoginAgrCallBack";
        }
    },
    
    //TMS 푸시 동의값 조회
    getTmsPushConfig : function() {
        common.app.appMktFlag = "";
        if (!common.app.appInfo.isapp) {
            return;
        }

        if (window.App
            && window.App.getTmsPushConfig) {
            window.App.getTmsPushConfig();
            return;
        }

        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.getTmsPushConfig) {
            var encodedParams = encodeURIComponent(JSON.stringify({
                getTmsPushConfig: "true",
            }));

            window.webkit.messageHandlers.getTmsPushConfig.postMessage({params: encodedParams});
            return;
        }

        location.href = "oliveyoungapp://getTmsPushConfig";
    },
    
    //TMS 푸시 동의값 수신
    getPushConfig : function(mktFlag) {
        if (common.app.appInfo.isapp) {
            common.app.appMktFlag = mktFlag;
        }
    },
    
    //TMS 푸시 동의값 설정
    setTmsPushConfig : function(mktFlag) {
        common.app.pushConfigResult = "";
        if (common.app.appInfo.isapp) {
            if(mktFlag==="N") {
                if(confirm("알림을 해제하시겠습니까?")) {
                    location.href = "oliveyoungapp://setTmsPushConfig?mktFlag="+mktFlag;
                }
            } else {
                location.href = "oliveyoungapp://setTmsPushConfig?mktFlag="+mktFlag;
            }
        }
    },
    
    //TMS 푸시 동의값 설정 결과 수신
    setTmsPushConfigCallback : function(result) {
        if (common.app.appInfo.isapp) {
            common.app.pushConfigResult = result;
        }
    },
    /* 3201008 안드로이드 앱, 모바일 팝업배너 '하루보지 않기' 동작 오류 */
    //앱-웹간 Cookie등 동기화 수행
    syncCookie : function() {
        if (!common.app.appInfo.isapp) {
            return;
        }

        if (window.App
            && window.App.syncCookie) {
            window.App.syncCookie();
            return;
        }

        if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.syncCookie) {
            var encodedParams = encodeURIComponent(JSON.stringify({
                syncCookie: "true",
            }));
            window.webkit.messageHandlers.syncCookie.postMessage({params: encodedParams});
            return;
        }

        // iOS App에는 syncCookie scheme이 없음
        // https://oyitsm.cj.net/jira/browse/CJOYCSD-295
        if (common &&
            common.app &&
            common.app.appInfo &&
            common.app.appInfo.isapp &&
            common.app.appInfo.ostype === common.app.IOS_TYPE) {

            return;
        }

        location.href = "oliveyoungapp://syncCookie";
    },
    
    // 선물하기 주소록 이름과 핸드폰 번호 받아오기
    setContactInfo : function(name, phoneNumber) {
    	
    	var rcvManNmObj,rcvManCellSctNoObj,rcvManCellTxnoNoObj,rcvManCellEndNoObj;
    	
    	rcvManNmObj = $("#rcvManNm");
    	rcvManCellSctNoObj = $("#rcvManCellSctNo");
    	rcvManCellTxnoNoObj = $("#rcvManCellTxnoNo");
    	rcvManCellEndNoObj = $("#rcvManCellEndNo");
    	
    	if( rcvManNmObj.length > 0 && rcvManCellSctNoObj.length > 0 
    			&& rcvManCellTxnoNoObj.length > 0 && rcvManCellEndNoObj.length > 0  ){
    		// 수령인명은 한글/영문/숫자만 가능
    		name = replaceStrSpecialChar(name);
    		if(name.length == 0){
    			alert("수령인명을 다시 확인하여 주세요. 특수문자는 기입하실 수 없습니다.");
    		}
    		
    		// 리셋
    		$("#rcvManNm").val("");
    		$("#rcvManCellSctNo").val("");
    		$("#rcvManCellTxnoNo").val("");
    		$("#rcvManCellEndNo").val("");
    		
    		// 불러온 값 셋팅
    		var numberLength = phoneNumber.length;
    		var hyphenIndex = phoneNumber.indexOf("-");
    		if(hyphenIndex == -1){
    			// 전화번호에 하이픈이 없는 경우 가공 필요
    			if(numberLength <= 10){
    				// 10자리 이하인 경우
    				phoneNumber = phoneNumber.substring(0,3) + "-" + phoneNumber.substring(3,6) + "-" + phoneNumber.substring(6,10); 
    			}else{
    				// 10자리 초과하는 경우
    				phoneNumber = phoneNumber.substring(0,3) + "-" + phoneNumber.substring(3,7) + "-" + phoneNumber.substring(7,11);
    			}
    		}
    		$("#rcvManNm").val(name.substring(0, 10));
    		$("#rcvManCellSctNo").val(phoneNumber.split("-")[0]);
    		$("#rcvManCellTxnoNo").val(phoneNumber.split("-")[1].substring(0, 4));
    		$("#rcvManCellEndNo").val(phoneNumber.split("-")[2].substring(0, 4));
    	}else{
    		var rStr = name;
        	
            var regExp = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9)]/gi;

            if(regExp.test(name)){
            	rStr = name.replace(regExp,"");
            }
            
        	// 불러온 값 셋팅
            var numberLength = phoneNumber.length;
            
            phoneNumber = phoneNumber.replace(/-/gi, "");
        	
        	var rcvManNmObj = $('input[name=rcvNm]');
        	var rcvManNoObj = $('input[name=rcvPhone]');
        	
        	var iIndex = rcvManNmObj.length - 1;

        	for( var i = 0; i < rcvManNmObj.length; i++ ){
        		if( common.isEmpty(rcvManNmObj[i].value) || common.isEmpty(rcvManNoObj[i].value) ){
        			iIndex = i;
        			break;	
        		}
        	}
        	rcvManNmObj[iIndex].value = rStr.substring(0, 10);
    		if(phoneNumber.length>7){
				rcvManNoObj[iIndex].value = phoneNumber.substr(0, 3)+"-"+phoneNumber.substr(3, 4)+"-"+phoneNumber.substr(7, 4);
			}else if (phoneNumber.length>3){
				rcvManNoObj[iIndex].value = phoneNumber.substr(0, 3)+"-"+phoneNumber.substr(3, 4);
			}else{
				rcvManNoObj[iIndex].value = phoneNumber.substr(0, 11);
			}
        	
    	}
        
    },

    /**
     * APP_애플 로그인 정보 요청 송신
     */
    callAppleLogin : function() {
        if (common.app.appInfo.isapp && common.app.appInfo.ostype == "10") {
            
            var varCompareVersionOs = common.app.compareVersion2(common.app.appInfo.osver, "13"); // OS 버전(미만 버전은 애플로그인 사용불가)
            var varCompareVersionApp = common.app.compareVersion(common.app.appInfo.appver, "2.3.5"); // APP 버전(이하 버전은 애플로그인 사용불가)
            
            if( (varCompareVersionOs  ==  ">" || varCompareVersionOs == "=") && varCompareVersionApp == ">" ) {

                try{
                    callLogEvent("로그인_애플로시작하기 클릭", {entry_source: "로그인", click_source: "애플로시작하기"});
                }catch (e) { void 0;}
                
                /* 애플로그인 DS 클릭지표 추가(로그인폼에서 애플로그인 버튼 선택 시) */
                common.wlog("easyLogin_apple_btn_mc");

                location.href = "oliveyoungapp://appleLogin";
            }
        }
    },
    
    /**
     * APP_애플 로그인 정보 수신
     */
    getAppleLoginInfo : function(appleIdentifier) {

        if (common.app.appInfo.isapp && common.app.appInfo.ostype == "10") { // 앱 & IOS

            // OS 버전 비교
            var varCompareVersionOs = common.app.compareVersion2(common.app.appInfo.osver, "13");
            
            if(varCompareVersionOs  ==  ">" || varCompareVersionOs == "=") { // 13 버전 이상
                
                if(!common.isEmpty(appleIdentifier)){ // 식별자값을 정상적으로 수신했을 때 간편로그인 사용여부 조회
                    
                    /* 애플로그인 DS 클릭지표 추가(로그인폼에서 애플로그인 인증 완료 시) */
                    common.wlog("easyLogin_apple_cert_cmpl_mc");
                    
                    var url = _secureUrl + "login/getAppleIdfyMbrLoginInfoJson.do";
                    var param = {easyLoginIdfy : appleIdentifier
                                ,easyLoginType : "apple" };

                    $.ajax({
                        type: 'POST',
                        url: url,
                        data: param,
                        async: false,
                        success: function(data){
                            var json = $.parseJSON(data);
                            void 0;
                            common.app.callbackAppleLogin(json);
                        }
                    });
                }
            }
        }
    },
    
    /**
     * APP_애플 로그인 정보 수신 콜백
     * iOS 네이티브에서 Apple Sign In 후 sub로 getAppleIdfyMbrLoginInfoJson.do 조회 결과를 수신
     *
     * 분기:
     *  1) easyLoginUseYn == "Y" → 기존 회원 (정회원/임시회원 재로그인) → doAppleLogin
     *  2) tempMemberEligible == "Y" → 신규 (sub 미존재) → 임시회원 약관동의 화면
     *  3) else → CJ ONE 연동 유도 → appleLoginCertAfter (loginForm.do)
     */
    callbackAppleLogin : function(data) {

        if (common.app.appInfo.isapp && common.app.appInfo.ostype == "10") { // 앱 & IOS
            
            // OS 버전 비교
            var varCompareVersionOs = common.app.compareVersion2(common.app.appInfo.osver, "13");
            
            if(varCompareVersionOs ==  ">" || varCompareVersionOs == "=") { // 13 버전 이상이면 로그인 진행
                
                var location_href = window.location.href; // 머무르고 있는 페이지를 확인하기 위한 선언

                if( 0 < location_href.indexOf("login/loginForm.do") ){ // 로그인폼에서 수신한 경우

                    if( data.easyLoginUseYn == "Y" ){ // 간편로그인 동의자인 경우
                        this.doAppleLogin(data);
                    } else if( data.tempMemberEligible == "Y" ) { // 임시회원 가입 가능 (Apple sub 미존재 = 신규)
                        // 네이티브가 전달한 identityToken을 sessionStorage에 보관 (약관동의 폼에서 사용)
                        if (data.identityToken) {
                            sessionStorage.setItem("appleIdToken", data.identityToken);
                        }
                        // 임시회원 전용 약관동의 화면으로 이동 (replace — 뒤로가기 시 로그인폼 재노출 방지)
                        // [CJOYMS-5697] loginForm.jsp의 returnUrlForApple hidden input 값을 URL에 릴레이
                        var returnUrlForApple = document.getElementById('returnUrlForApple');
                        var returnUrlVal = returnUrlForApple ? returnUrlForApple.value : '';
                        var tempMemberAgreeUrl = _secureUrl + "login/tempMemberAgreeForm.do?easyLoginIdfy=" + encodeURIComponent(data.easyLoginIdfy);
                        if (returnUrlVal) {
                            tempMemberAgreeUrl += "&returnUrl=" + encodeURIComponent(returnUrlVal);
                        }
                        location.replace(tempMemberAgreeUrl);
                    } else {
                        this.appleLoginCertAfter(data,"Y");
                    }
                    
                // 로그인폼이 아닌 곳에서 수신한 경우
                } else {
                    var form = $('<form></form>');
                    var url = _secureUrl + "login/loginForm.do";
                    var fvEasyLoginType        = $("<input type='hidden' id='easyLoginType'        name='easyLoginType'        value='apple' />");
                    var fvAppleIdentifier      = $("<input type='hidden' id='appleIdentifier'      name='appleIdentifier'      value='"+data.easyLoginIdfy+"' />");
                    var fvAppleLoginCertSucsYn = $("<input type='hidden' id='appleLoginCertSucsYn' name='appleLoginCertSucsYn' value='Y' />");
                    
                    form.attr('action', url);
                    form.attr('method', 'post');
                    form.appendTo('body');
                    form.append(fvEasyLoginType);
                    form.append(fvAppleIdentifier);
                    form.append(fvAppleLoginCertSucsYn);
                    form.submit();
                }
            }
        }
    },
    
    /**
     * 애플 로그인 off 회원이 인증 성공 시, 통합회원 로그인을 유도 - 개발 페이지에 override 구현
     */
    appleLoginCertAfter : function(data, appleLoginCertSucsYn) {
        
    },
    
    /**
     * 애플 로그인 수행 - 개발 페이지에 override 구현
     */
    doAppleLogin : function(data) {
        // /x2-commerce-mobile/webroot/mc-static-root/js/login/login.js
    },

    /**
     * APP_애플 로그인 정보 수신 실패or취소
     */
    getAppleLoginFail : function() {
        
        var location_href = window.location.href; // 머무르고 있는 페이지를 확인하기 위한 선언
        
        if( 0 < location_href.indexOf("mypage/getMemberInfoChangeForm.do") ){ // 마이페이지에서만 동작
            $('#applelogin').prop("checked",false);
        }
    },

    addNotchPixel : function(px) {
        return common.app.appInfo.hassafearea == "true"?common.app.addPixel(px,34):px;
    },
    addPixel : function(px, value) {
        var intPx = parseInt(px);
        intPx += value;
        return intPx+"px";
    },

    // 새로 개발하는 네이티브 탭바의 오른쪽 최근 본 상품에 상품 번호와 이미지를 넣어준다.
    setRecentlyViewedItemWithNativeTabBar: function(data) {
        var message = {
            name: "JS_BRIDGE_MAIN",
            callFunctionName: "setRecentlyViewedItem",
            json: {
                goodsNo: data.goodsNo ? data.goodsNo : null,
                goodsImg:  data.goodsImg ? data.goodsImg.replace("&SF=webp", "") : null
            }
        };

        var encodedParams = encodeURIComponent(JSON.stringify(message));

        var aosFuncNm1 = "JS_BRIDGE_MAIN";
        var aosFuncNm2 = "setRecentlyViewedItem";
        var iosFuncNm = "JS_BRIDGE_MAIN";

        this.sendAppInterface(
            aosFuncNm1,
            aosFuncNm2,
            iosFuncNm,
            encodedParams);
    },
    setNativeTabBar: function (isShow, animated) {
        var message = {
            animated: animated === undefined ? true : animated
        }
        var stringMessage = JSON.stringify(message);

        if (isShow) {
            if (window.App && window.App.showNativeTabBar) {
                window.App.showNativeTabBar(stringMessage);
                return;
            }

            if (
                window.webkit &&
                window.webkit.messageHandlers &&
                window.webkit.messageHandlers.showNativeTabBar
            ) {
                window.webkit.messageHandlers.showNativeTabBar.postMessage(stringMessage);
                return;
            }
        } else {
            if (window.App && window.App.hideNativeTabBar) {
                window.App.hideNativeTabBar(stringMessage);
                return;
            }

            if (
                window.webkit &&
                window.webkit.messageHandlers &&
                window.webkit.messageHandlers.hideNativeTabBar
            ) {
                window.webkit.messageHandlers.hideNativeTabBar.postMessage(stringMessage);
                return;
            }
        }
    }
};

;(function($){
    common.app.init();
})(jQuery);

/*$(document).ready(function() {
    common.app.init();
});*/
